export default function Arrow() {
  return (
    <svg fill="none" height="11" viewBox="0 0 7 11" width="7" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.26717 1.00004L5.53433 5.24268L1.26717 9.48532" id="Rectangle" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}
